var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1663583-5a39-4ae5-b814-9b11cb2032c3",
    gradientUnits: "userSpaceOnUse",
    x1: 26,
    x2: 26,
    y1: -4.576,
    y2: 65.721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38d6a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#32caae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#22abc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#0879f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#0069ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "982ba75b-fb91-49c8-b472-cdc8bf053f69",
    x1: 34,
    x2: 34,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d8118543-854c-4c02-9522-75605ddac68c",
    x1: 48,
    x2: 48,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "41028406-1106-4065-b0d4-2b2801cf1271",
    x1: 54.5,
    x2: 54.5,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8bef23e-a58c-4a24-b7d6-1e7b6c4c40fb",
    x1: 50,
    x2: 50,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "620b536c-115a-41d7-b7f5-9d799518e52f",
    x1: 45,
    x2: 45,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce86441b-f5a3-4369-9c57-a8021bfbdd2d",
    x1: 56,
    x2: 56,
    xlinkHref: "#a1663583-5a39-4ae5-b814-9b11cb2032c3",
    y1: -4.576,
    y2: 65.721
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29 47h-23a6.006 6.006 0 0 1 -6-6v-35a6.006 6.006 0 0 1 6-6h10a5.459 5.459 0 0 1 4.076 1.83l4.894 5.505a4.958 4.958 0 0 0 3.706 1.665h17.324a6.006 6.006 0 0 1 6 6v4a1 1 0 0 1 -2 0v-4a4 4 0 0 0 -4-4h-17.324a6.964 6.964 0 0 1 -5.2-2.335l-4.895-5.506a3.456 3.456 0 0 0 -2.581-1.159h-10a4 4 0 0 0 -4 4v35a4 4 0 0 0 4 4h23a1 1 0 0 1 0 2z",
    fill: "url(#a1663583-5a39-4ae5-b814-9b11cb2032c3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 7a1 1 0 0 1 -1-1 4 4 0 0 0 -4-4h-17a1 1 0 0 1 0-2h17a6.006 6.006 0 0 1 6 6 1 1 0 0 1 -1 1z",
    fill: "url(#982ba75b-fb91-49c8-b472-cdc8bf053f69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 64h-24a4 4 0 0 1 -4-4v-34a4 4 0 0 1 4-4h15a1 1 0 0 1 .676.263l12 11a1 1 0 0 1 .324.737v26a4 4 0 0 1 -4 4zm-24-40a2 2 0 0 0 -2 2v34a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-25.56l-11.389-10.44z",
    fill: "url(#d8118543-854c-4c02-9522-75605ddac68c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 36h-7a3 3 0 0 1 -3-3v-6a1 1 0 0 1 2 0v6a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2z",
    fill: "url(#41028406-1106-4065-b0d4-2b2801cf1271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 43h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z",
    fill: "url(#b8bef23e-a58c-4a24-b7d6-1e7b6c4c40fb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 49h-18a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2z",
    fill: "url(#d8118543-854c-4c02-9522-75605ddac68c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 55h-12a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z",
    fill: "url(#620b536c-115a-41d7-b7f5-9d799518e52f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 55h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z",
    fill: "url(#ce86441b-f5a3-4369-9c57-a8021bfbdd2d)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDark);
export default __webpack_public_path__ + "static/media/FolderDark.3dc9d339.svg";
export { ForwardRef as ReactComponent };